import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject } from 'rxjs';

import { environment } from 'environments/environment';

import { Language } from '@classes/language';
import { UiService } from './ui.service';

@Injectable({
    providedIn: 'root'
})
export class LanguageService {
    languageChanged = new Subject<string>();

    private baseUrl: string = environment.apiUrl + 'languages';

    constructor(
        private http: HttpClient,
        private translateSrv: TranslateService,
        private uiSrv: UiService
    ) { }

    getList(): Observable<Language[]> {
        return this.http.get<Language[]>(this.baseUrl);
    }

    setCurrentLanguage(lang?: string): void {
        const selLanguage: string = lang || '';

        this.uiSrv.translationLoadingStateChanged.next(true);

        this.translateSrv.reloadLang(selLanguage)
        .subscribe(() => {
            this.translateSrv.use(selLanguage);
            this.languageChanged.next(selLanguage);
            this.uiSrv.translationLoadingStateChanged.next(false);
        });
    }
}
